import { DataDisplayEvent } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutCarrierLaneRateQuickInfo } from "./autogen/AutogenLayoutCarrierLaneRateQuickInfo";

export class CarrierLaneRateQuickInfo extends AutogenLayoutCarrierLaneRateQuickInfo {

    textboxDescriptionOnDataDisplay(event: DataDisplayEvent) {
        this.textboxDescription.printableLabel.link = LayoutUrl.create(
            "lme/dispatch/rates/CarrierRate",
            {
                mode: "update",
                key: event.rowData?.get("carrier_rate_id"),
                laneRateId: event.rowData?.get("id")
            }
        );
    }
    
    sourceCarrierLaneRateAfterExecution(event) {
        const carrierLaneRate = event.data;
        const showCommitments = carrierLaneRate != null && !carrierLaneRate.isNull('commitment_amount');
        this.panelCommitments.visible = showCommitments;
    }
}